import React from 'react';
import { Card, CardContent, CardHeader } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';

const AdminStocksSkeleton = () => {
  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded" />
            <Skeleton className="h-9 w-44" />
          </div>
          <Skeleton className="mt-2 h-5 w-80" />
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <Card key={index}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-4 w-4 rounded-full" />
            </CardHeader>
            <CardContent>
              <Skeleton className="mb-2 h-8 w-12" />
              <Skeleton className="h-3 w-32" />
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <Skeleton className="mb-1 h-6 w-48" />
          <Skeleton className="h-4 w-72" />
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex flex-col gap-4 sm:flex-row">
            <Skeleton className="h-10 flex-1 rounded-md" />
            <Skeleton className="h-10 w-[180px] rounded-md" />
            <Skeleton className="h-10 w-[180px] rounded-md" />
          </div>

          <div className="overflow-hidden rounded-lg border">
            <div className="grid grid-cols-6 gap-4 border-b bg-gray-50/50 px-4 py-3">
              {[...Array(6)].map((_, index) => (
                <Skeleton key={index} className="h-4 w-20" />
              ))}
            </div>

            {[...Array(8)].map((_, index) => (
              <div key={index} className="grid grid-cols-6 gap-4 border-b px-4 py-4 last:border-b-0">
                {[...Array(6)].map((__, cellIndex) => (
                  <Skeleton key={cellIndex} className="h-4 w-full max-w-[120px]" />
                ))}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export { AdminStocksSkeleton };
